import CustomList from '@/pages/customManage/customList'

export default [
  {
    path: '/customList',
    name: 'CustomList',
    component: CustomList,
    meta: { name: '客户列表' }
  },
  {
    path: '/customlabel',
    name: 'customlabel',
    component: () => import('@/pages/customManage/customlabel'),
    meta: { name: '标签管理' }
  }
]



// WEBPACK FOOTER //
// ./src/router/customManage/customList.js